const SearchResultMarkerSvg = ({ width = 18, height = 24 }: { width?: number; height?: number }) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 27 36' fill='none'>
    <path
      d='M27 13.5C27 19.6453 18.7734 30.5859 15.1664 35.1C14.3016 36.1758 12.6984 36.1758 11.8336 35.1C8.22656 30.5859 0 19.6453 0 13.5C0 6.04688 6.04688 0 13.5 0C20.9531 0 27 6.04688 27 13.5Z'
      fill='#0037DB'
    />
    <path
      d='M26.5 13.5C26.5 14.9379 26.0153 16.7014 25.1976 18.6383C24.3834 20.5669 23.2563 22.628 22.0102 24.6493C19.5183 28.6916 16.5744 32.537 14.776 34.7876C14.1114 35.6133 12.8886 35.6133 12.224 34.7876C10.4256 32.537 7.4817 28.6916 4.98978 24.6493C3.74367 22.628 2.61658 20.5669 1.8024 18.6383C0.984727 16.7014 0.5 14.9379 0.5 13.5C0.5 6.32302 6.32302 0.5 13.5 0.5C20.677 0.5 26.5 6.32302 26.5 13.5Z'
      stroke='white'
    />
  </svg>
);

export default SearchResultMarkerSvg;
